export class AppRoles {
    public static readonly ROLE_GESTOR: string = 'ROLE_GESTOR';
    public static readonly ROLE_USUARIO: string = 'ROLE_USUARIO';
}
